import { Key, use, useCallback, useEffect, useRef, useState } from "react";
import axiosInstance from "../../../../axios/axios";
import { END_POINTS } from "../../../../shared";
import _, { has, set } from "lodash";
import "./RolePermissions.scss";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { toast } from "react-toastify";

import "react-loading-skeleton/dist/skeleton.css";
import AntSwitch from "../../../../components/AntSwitch";
import WhiteTooltip from "../../../../components/WhiteTooltip";
import { useRoleContext } from "../RoleContext";
import { useTheme } from "@mui/material";
import RegionAssets from "./RegionAssets";
import { SkeletonLoader } from "../../../../modules/dashboard/shared";
import useRolePermissions from "../../../../shared/hooks/useRolePermissions";
import { ROLES_CONTENT_PROPS } from "../../../../shared/constants/constant-data";

const RolePermissions = ({ role, Roles, onCheckUnsavedChanges }: any) => {
  const [roleDetails, setRoleDetails] = useState<any>(null);
  const [defaultValues, setDefaultValues] = useState<any>({});
  const [isApiCallDone, setIsApiCallDone] = useState<boolean>(false);
  const [apiCount, setApiCount] = useState<number>(0);
  const [filterColumnData, setFilterColumnData] = useState<Map<string, any>>(
    new Map()
  );
  const [subPermissionsMap, setSubPermissionsMap] = useState<{
    [parentId: string]: any[];
  }>({});
  const [accordianPermissions, setAccordianPermissions] = useState<any[]>([]);
  const [selectedState, setSelectedState] = useState<number>(1);
  const [isSaveDisable, setIsSaveDisable] = useState<boolean>(false);
  const [isSaveChanges, setIsSaveChanges] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [enableAll, setEnableAll] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState<any>(null);
  const [roleCheck, setRoleCheck] = useState<any>(null);
  const [openAccordions, setOpenAccordions] = useState<{
    [key: string]: boolean;
  }>({});
  const [isToogle, setIsToogle] = useState<boolean>(false);
  const scrollContainerRef = useRef<HTMLUListElement>(null);
  const [whiteBoxHeight, setWhiteBoxHeight] = useState<number>(0);
  const whiteBoxRef = useRef<HTMLDivElement>(null);
  const { setRoleSave } = useRoleContext();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [globalRegionsIdLabel, setGlobalRegionsIdLabel] = useState<any[]>([]);
  const [loadingRegions, setLoadingRegions] = useState(false);
  const [loadingDevices, setLoadingDevices] = useState(false);

  const [globalRegions, setGlobalRegions] = useState<any>(null);
  const [globalDevicesFilter, setGlobalDevicesFilter] = useState<any[]>([]);
   const { hasPermissions } = useRolePermissions();
  const [allRegionsSelected, setAllRegionsSelected] = useState(true);

  const getRoleDetails = useCallback(async (role: any) => {
    setIsApiCallDone(false);
    setApiCount(0);
    try {
      const response = await axiosInstance.get<any>(
        `${END_POINTS.ROLE_PERMISSIONS}/${role?.id}`
      );
      roleDetailsCallback(response.data);
    } catch (error) {
      console.error("Failed to fetch role details:", error);
    }
  }, []);

  useEffect(() => {
    if (roleDetails?.id) {
      setGlobalRegions([]);
      setGlobalDevicesFilter([]);
      fetchGlobalRegions(roleDetails.id);
    }
  }, [roleDetails]);

  const processRegionsIndeterminate = (regions: any[]): any[] => {
    return regions.map((region) => {
      let updatedRegion = { ...region };

      if (updatedRegion.data && updatedRegion.data.length > 0) {
        updatedRegion.data = processRegionsIndeterminate(updatedRegion.data);

        const allSelected = updatedRegion.data.every(
          (child: any) => child.selected
        );
        const noneSelected = updatedRegion.data.every(
          (child: any) => !child.selected
        );

        if (allSelected || noneSelected) {
          updatedRegion.indeterminate = false;
        } else {
          updatedRegion.indeterminate = true;
        }
      } else {
        updatedRegion.indeterminate = false;
      }

      return updatedRegion;
    });
  };

  const fetchGlobalRegions = async (roleId: string) => {
    try {
      setLoadingRegions(true);
      const response = await axiosInstance.post(
        "authentication/global-regions",
        { role_id: roleId }
      );
      const regionsData = response.data.data;
      const updatedRegions = processRegionsIndeterminate(regionsData);
      setGlobalRegions(updatedRegions);
      //setGlobalRegions(regionsData);
      //setGlobalRegions(response.data.data); // Assign response here
      //const minimalRegions = extractIdLabelTree(regionsData);
      //console.log('Minimal regions:', minimalRegions); // ← New variable
      //setGlobalRegionsIdLabel(minimalRegions); // ← New variable
      if (updatedRegions && updatedRegions.length > 0) {
        const minimalRegions = extractIdLabelTree(updatedRegions);
        setGlobalRegionsIdLabel(minimalRegions);

        // Fetch devices only if minimalRegions is available
        fetchGlobalDevices(minimalRegions);
      }
      // const devicePayload = {
      //   role_id: roleDetails.id,
      //   data: minimalRegions
      // };

      // const deviceResponse = await axiosInstance.post(
      //   'securityscan/global-devices-filter',
      //   devicePayload
      // );
      // setGlobalDevicesFilter(deviceResponse.data.data);
    } catch (error) {
      console.error("Error fetching global regions:", error);
    } finally {
      setLoadingRegions(false);
    }
  };

  const fetchGlobalDevices = async (minimalRegions: any[]) => {
    try {
      setLoadingDevices(true);
      const devicePayload = {
        role_id: roleDetails.id,
        data: minimalRegions,
      };
      const deviceResponse = await axiosInstance.post(
        "securityscan/global-devices-filter",
        devicePayload
      );
      const devices = processRegionsIndeterminate(deviceResponse.data.data);
      setGlobalDevicesFilter(devices);
    } catch (error) {
      console.error("Error fetching global devices:", error);
    } finally {
      setLoadingDevices(false);
    }
  };

  const extractIdLabelTree = (regions: any[]): any[] => {
    return regions
      .filter((region) => region.selected || region.indeterminate) // Keep if selected or partially selected
      .map((region) => {
        const result: any = {
          id: region.id,
          label: region.label,
        };

        if (region.data && region.data.length > 0) {
          const filteredChildren = extractIdLabelTree(region.data);
          if (filteredChildren.length > 0) {
            result.data = filteredChildren;
          }
        }

        return result;
      });
  };

  const roleDetailsCallback = (response: any) => {
    setIsApiCallDone(true);
    if (response.status === 200) {
      const data = JSON.parse(JSON.stringify(response.data));
      if (data.permissions?.length) {
        const newScanItem = data.permissions.find((p: any) => p.code === "new_scan");
        const newScanId = newScanItem?.id;

        const filteredPermissions = data.permissions.filter(
          (permission: any) => {
            if (permission.label?.toLowerCase() === "cloud security") return false;
            if (permission.code === "new_scan") return false;
            if (newScanId && permission.parent_id === newScanId) return false;
            if (
              permission.code === "cloud_agent_permissions_new" ||
              permission.code === "create_edit_agents_new" ||
              permission.code === "view_agent_cloud_new"
            ) {
              return false;
            }
            return true;
          }
        );
        const sortedPermissions = _.orderBy(
          filteredPermissions,
          ["label"],
          ["asc"]
        );
        const topLevelPermissions: any[] = [];
        const subPermissionsMap: { [parentId: string]: any[] } = {};
        const accordianPermissions: any[] = [];
        const defaultValues: { [key: string]: boolean | number } = {};
        
        // Explicitly define cloud agent permissions as false in defaultValues
        defaultValues["cloud_agent_permissions_new"] = false;
        defaultValues["create_edit_agents_new"] = false;
        defaultValues["view_agent_cloud_new"] = false;

        sortedPermissions.forEach((permission: any) => {
          if (permission.code === "new_scan_v2") {
            permission.label = "New scan";
          }
          permission.is_type_view = permission.label.includes("View");
          if (!permission.parent_id) {
            topLevelPermissions.push(permission);
          } else {
            if (!subPermissionsMap[permission.parent_id]) {
              subPermissionsMap[permission.parent_id] = [];
            }
            subPermissionsMap[permission.parent_id].push(permission);
          }
          if (permission.type === "toggle") {
            permission.value = permission.value === "true" || false;
          } else {
            permission.value = Number(permission.value);
          }
          if (permission.type === "accordian") {
            accordianPermissions.push(permission);
          }
          if (permission.code) {
            defaultValues[permission.code] = permission.value;
          }
        });
        sortedPermissions.forEach((permission: any) => {
          if (accordianPermissions.length > 0) {
            accordianPermissions.forEach((accordion) => {
              if (accordion.id === permission.parent_id) {
                subPermissionsMap[accordion.parent_id!].push(permission);
              }
            });
          }
        });
        topLevelPermissions.forEach((parentPermission) => {
          if (parentPermission.id) {
            parentPermission.subPermissions =
              subPermissionsMap[parentPermission.id] || [];
          }
        });
        setRoleDetails({ ...data, permissions: topLevelPermissions });
        setDefaultValues(defaultValues);
        setSubPermissionsMap(subPermissionsMap);
        setAccordianPermissions(accordianPermissions);
        const roleIndex = Roles?.findIndex((role: any) => {
          return role.name === data?.name;
        });
        if (roleIndex > -1) {
          if (Roles) {
            Roles[roleIndex].permissions = { ...defaultValues };
          }
          setRoleCheck(Roles[roleIndex]);
        }
      }
    }
  };

  const renderSubPermissions = (selectedPermission: any) => {
    if (
      selectedPermission?.subPermissions &&
      selectedPermission?.subPermissions.length > 0
    ) {
      return (
        <div className="sub-permissions">
          <div className="tool-sublist">
            <ul className="tool_list">
              {selectedPermission?.subPermissions?.map((subPermission: any) => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "11px 40px",
                  }}
                >
                  <div className="tool-label">
                    <label>{subPermission?.label}</label>
                  </div>
                  <div className="tool_switch right_ele">
                    {subPermission.type === "toggle" ? (
                      // <Switch
                      //   checked={roleCheck?.permissions[subPermission.code]}
                      //   onChange={(e) => toggleSubPermissionRole(e, subPermission, selectedPermission)}
                      //   disabled={isRoleEditable(role)}
                      //   sx={{
                      //     "& .Mui-checked + .MuiSwitch-track": {
                      //       backgroundColor: "rgb(94, 214, 94);",
                      //     },
                      //   }}
                      // />
                      <AntSwitch
                        checked={roleCheck?.permissions[subPermission.code]}
                        onChange={(e) =>
                          toggleSubPermissionRole(
                            e,
                            subPermission,
                            selectedPermission,
                            false
                          )
                        }
                        disabled={isRoleEditable(role) || !hasPermissions(ROLES_CONTENT_PROPS.MODIFY_ROLE_PERMISSION) || ((role?.name === "Read-Only" || role?.name === "Read Only") && subPermission.code === "create_edit_agent_new" && roleCheck?.permissions[subPermission.code] === true)}
                      />
                    ) : (
                      <div className="tool_value">
                        <div
                          className={`value-button ${
                            isRoleEditable(role) ? "disabled" : ""
                          }`}
                          onClick={() =>
                            onStepperChange(
                              role,
                              subPermission.code,
                              "decrement"
                            )
                          }
                        >
                          -
                        </div>
                        <input
                          type="number"
                          value={role.permissions[subPermission.code]}
                          readOnly
                          className="pointer-events"
                        />
                        <div
                          className={`value-button ${
                            isRoleEditable(role) ? "disabled" : ""
                          }`}
                          onClick={() =>
                            onStepperChange(
                              role,
                              subPermission.code,
                              "increment"
                            )
                          }
                        >
                          +
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </ul>
          </div>
        </div>
      );
    } else {
      return (
        <div className="no-data">
          <p>The selected module has no sub permissions.</p>
        </div>
      );
    }
  };

  const toggleAccordion = (id: any) => {
    setOpenAccordions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const renderAccordianContent = (selectedPermission: any) => {
    if (
      selectedPermission?.subPermissions &&
      selectedPermission?.subPermissions.length > 0
    ) {
      return (
        <div className="accordian-content">
          {selectedPermission?.subPermissions?.map((accordion: any) => (
            <div className="accordian-sublist">
              {accordion.type === "accordian" && (
                <Accordion
                  key={accordion.id}
                  expanded={openAccordions[accordion.id]}
                  onChange={() => toggleAccordion(accordion.id)}
                  style={{
                    boxShadow: "none",
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className="accordian-header">
                      {accordion.label}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
<ul className={`accordian-list ${isDarkMode ? "dark-mode" : "light-mode"}`}>
                      {selectedPermission.subPermissions.map(
                        (subPermission: any) =>
                          subPermission.parent_id === accordion.id && (
                            <li key={subPermission.code} className="list-items">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <label className="accordian-label">
                                  {subPermission.label}
                                </label>
                                {subPermission.type === "toggle" && (
                                  <div className="tool_switch right_ele">
                                    {/* <Switch
                                             checked={roleCheck.permissions[subPermission.code]}
                                             onChange={(e) => toggleSubPermissionRole(e, subPermission, selectedPermission)}
                                             disabled={isRoleEditable(role)}
                                             sx={{
                                              "& .Mui-checked + .MuiSwitch-track": {
                                                backgroundColor: "rgb(94, 214, 94);", // Replace with your desired color
                                              },
                                            }}
                                           /> */}
                                    <AntSwitch
                                      checked={
                                        roleCheck.permissions[
                                          subPermission.code
                                        ]
                                      }
                                      onChange={(e) =>
                                    toggleSubPermissionRole(
                                          e,
                                          subPermission,
                                          selectedPermission,
                                          true,
                                          subPermission.is_type_view
                                        )
                                      }
                                      disabled={isRoleEditable(role) || !hasPermissions(ROLES_CONTENT_PROPS.MODIFY_ROLE_PERMISSION) || ((role?.name === "Read-Only" || role?.name === "Read Only") && subPermission.code === "create_edit_agent_new" && roleCheck?.permissions[subPermission.code] === true)}
                                    />
                                  </div>
                                )}
                              </div>
                            </li>
                          )
                      )}
                    </ul>
                  </AccordionDetails>
                </Accordion>
              )}
            </div>
          ))}
        </div>
      );
    } else {
      return (
        <div className="no-data">
          <p>The selected module has no sub permissions.</p>
        </div>
      );
    }
  };

  const toggleEnableAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEnableAll(event.target.checked);
    updateRolePermissions(event.target.checked);
  };

  const updateRolePermissions = (flag: boolean) => {
    const roles: any = roleCheck?.permissions;
    Object.keys(roles)?.forEach((item: any) => {
      if (typeof roles[item] === "boolean") {
        roles[item] = flag;
      } else {
        roles[item] = flag ? 1 : 0;
      }
    });
  };

  const toggleSubPermissionRole = (
    event: React.ChangeEvent<HTMLInputElement>,
    subPermission: any,
    parentPermission: any,  
    isCloud:any,
    isIndependent: boolean = false
  ) => {
    console.log("parentPermission", parentPermission);
    const isChecked = event.target.checked;
    setRoleCheck((prevRoleCheck: any) => {
      const updatedPermissions = { ...prevRoleCheck.permissions };
      updatedPermissions[subPermission.code] = isChecked;

      if (!isIndependent || !isChecked) {
        if (isChecked && !updatedPermissions[parentPermission.code]) {
          updatedPermissions[parentPermission.code] = true;
        }
        if(subPermission.is_type_view){
          parentPermission.subPermissions.forEach((item: any) => {
            if(isCloud){
              if(!item.is_type_view && item.parent_id === subPermission.parent_id){
                updatedPermissions[item.code] = isChecked;
              }
            } else {
              if (!item.is_type_view) {
              updatedPermissions[item.code] = isChecked;
            }
            }
          })  
        }
        const hasAnyTrue = parentPermission.subPermissions.some(
          (perm: any) => perm.type === "toggle" && perm.is_type_view === true
        );
        if (hasAnyTrue && isChecked && !subPermission.is_type_view && !isCloud) {
         parentPermission.subPermissions.forEach((prem:any) => {
          if (prem.is_type_view) {
             updatedPermissions[prem.code] = true;
          }
        });
      }
      if( isCloud && hasAnyTrue && isChecked && !subPermission.is_type_view){
        parentPermission.subPermissions.forEach((prem:any) => {
          if (prem.is_type_view && prem.parent_id === subPermission.parent_id) {
             updatedPermissions[prem.code] = true;
          }
        });
      }
      if(!isChecked){
        const hasAllFalse = isCloud ? parentPermission.subPermissions
    .filter(
      (perm: any) =>
        perm.code !== subPermission.code &&
        typeof perm.value === 'boolean'
    )
    .every(
      (perm: any) =>
        perm.type === 'toggle' && updatedPermissions[perm.code] === false
    )
:parentPermission.subPermissions
          .filter((perm: any) => perm.code !== subPermission.code)
          .every((perm: any) => perm.type === "toggle" && updatedPermissions[perm.code] === false);
        if (hasAllFalse) {
          updatedPermissions[parentPermission.code] = false;
        }
      }
      }
      const newRoleCheck = {
        ...prevRoleCheck,
        permissions: updatedPermissions,
      };
      const booleanPermissions = Object.values(updatedPermissions).filter(
        (value) => typeof value === "boolean"
      );
      const allPermissionsTrue = booleanPermissions.every(
        (value) => value === true
      );
      setEnableAll(allPermissionsTrue);
      return newRoleCheck;
    });
  };

  const isRoleEditable = (role: any) => {
    const isEditable = role?.default_role ? true : false;
    return isEditable;
  };

  const updateState = (
    event: React.MouseEvent<HTMLElement>,
    newState: number
  ) => {
    if (newState === null) {
      return;
    }
    setSelectedState(newState);
  };

  const handlePermissionClick = (permission: any) => {
    setOpenAccordions({});
    const isToogle = permission.subPermissions.some(
      (permission: any) => permission.type === "accordian"
    );
    setIsToogle(isToogle);
    setSelectedPermission(permission);
  };

  const toggleParentRole = (
    event: React.ChangeEvent<HTMLInputElement>,
    role: any,
    subPermissions: any
  ) => {
    const isChecked = event.target.checked;
    const updatedPermissions = { ...roleCheck.permissions };
    updatedPermissions[role.code] = isChecked;
    if (subPermissions) {
      subPermissions.forEach((item: any) => {
        updatedPermissions[item.code] = isChecked;
      });
    }
    const newRoleCheck = {
      ...roleCheck,
      permissions: updatedPermissions,
    };
    setRoleCheck(newRoleCheck);
    const booleanPermissions = Object.values(updatedPermissions).filter(
      (value) => typeof value === "boolean"
    );
    const allPermissionsTrue = booleanPermissions.every(
      (value) => value === true
    );
    setEnableAll(allPermissionsTrue);
  };

  const onStepperChange = (role: any, code: string, action: string) => {
    // Stepper change logic
  };

  // const saveChangesCallback = (response: any) => {
  //   console.log('Save successful', response);
  //   if (response?.status === 200) {
  //       const role: any = { id: response.data?.data?.role_id};
  //       getRoleDetails(role);
  //        toast('Permissions have been saved successfully!',{type:"success"});
  //     }
  // };

  const saveChanges = async () => {
    const roleReq: any = {
      role_name: roleCheck?.name,
      role_id: roleCheck?.id,
      permissions: [],
    };

    for (const [key, value] of Object.entries(roleCheck?.permissions)) {
      if (
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
      ) {
        const permissionObj = { code: key, value: value.toString() };
        roleReq.permissions.push(permissionObj);
      }
    }

    try {
      // First API call: Save role permissions
      const response = await axiosInstance.post(END_POINTS.SAVE_USERS, roleReq);

      if (response?.status === 200) {
        const role: any = { id: response.data?.data?.role_id };
        getRoleDetails(role);
        toast("Permissions have been saved successfully!", { type: "success" });
      }
    } catch (error) {
      console.error("Save failed", error);
      toast("Save failed. Please try again.", { type: "error" });
    }
  };

  const resetValues = (role: any) => {
    setOpenDialog(true);
  };

  const handleDialogClose = (confirm: boolean) => {
    setOpenDialog(false);
    if (confirm) {
      setRoleCheck((prevDetails: any) => {
        const updatedPermissions = { ...defaultValues };
        const booleanPermissions = Object.values(updatedPermissions).filter(
          (value) => typeof value === "boolean"
        );
        const allPermissionsTrue = booleanPermissions.every(
          (value) => value === true
        );
        setEnableAll(allPermissionsTrue);

        return {
          ...prevDetails,
          permissions: updatedPermissions,
        };
      });
    }
  };

  // const  isSaveButtonEnableDisable = () => {
  //   let isEnable = false;
  //   if (roleCheck?.permissions) {
  //     const rolePermissions = Object.values(roleCheck.permissions);
  //     isEnable = rolePermissions.every((value: any) => value === defaultValues[value]);
  //   }
  //   return isEnable;
  // };

  const isSaveButtonEnableDisable = () => {
    if (!roleCheck?.permissions || !defaultValues) {
      return true;
    }
    const hasChanges = Object.keys(roleCheck.permissions).some((key) => {
      const roleValue = roleCheck.permissions[key];
      const defaultValue = defaultValues[key];
      if (
        (typeof roleValue === "boolean" ||
          roleValue === 0 ||
          roleValue === 1) &&
        (typeof defaultValue === "boolean" ||
          defaultValue === 0 ||
          defaultValue === 1)
      ) {
        return roleValue !== defaultValue;
      }
      return false;
    });
    return !hasChanges;
  };

  const saveChangesRegion = async () => {
    try {
      // Check if all regions are selected
      const allRegionsSelected = Object.values(globalRegions).every(
          (region: any) => region.selected === true
      );

      // Check if all devices are selected
      const allDevicesSelected = Object.values(globalDevicesFilter).every(
          (device: any) => device.selected === true
      );

      const secondaryPayload = {
        role_id: role?.id,
        all_devices: allDevicesSelected,
        all_regions: allRegionsSelected,
        device_list: globalDevicesFilter,
        region_list: globalRegions,
      };
      const response = await axiosInstance.post(
        "securityscan/saving-data",
        secondaryPayload
      );
      if (response?.status === 200) {
        toast("Permissions have been saved successfully!", { type: "success" });
      }
    } catch (error) {
      console.error("Save failed", error);
      toast("Save failed. Please try again.", { type: "error" });
    }
  };

  useEffect(() => {
    if (role && role.id) {
      getRoleDetails(role);
      setSelectedState(1);
    }
  }, [role, getRoleDetails]);

  useEffect(() => {
    if (roleDetails?.permissions?.length) {
      const initialPermission = roleDetails.permissions[0];
      setSelectedPermission(initialPermission);
      const isToogle = initialPermission.subPermissions.some(
        (permission: any) => permission.type === "accordian"
      );
      setIsToogle(isToogle);
      const updatedPermissions = { ...roleCheck.permissions };
      if (updatedPermissions) {
        const booleanPermissions = Object.values(updatedPermissions).filter(
          (value) => typeof value === "boolean"
        );
        const allPermissionsTrue = booleanPermissions.every(
          (value) => value === true
        );
        setEnableAll(allPermissionsTrue);
      }
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }, [roleDetails]);
  useEffect(() => {
    if (whiteBoxRef.current) {
      const height = whiteBoxRef.current.offsetHeight;
      setWhiteBoxHeight(height);
    }
  }, [isApiCallDone]);
  useEffect(() => {
    setRoleSave(roleCheck);
  }, [roleCheck]);
  useEffect(() => {
    if (onCheckUnsavedChanges) {
      onCheckUnsavedChanges(() => isSaveButtonEnableDisable());
    }
  }, [roleCheck, defaultValues, onCheckUnsavedChanges]);
  const skeletonRowHeight = 25;
  const skeletonRowSpacing = 10;
  const totalRowHeight = skeletonRowHeight + skeletonRowSpacing + 5;
  const skeletonCount = Math.floor(whiteBoxHeight / totalRowHeight);

  if (!isApiCallDone) {
    return (
      <div 
        className="white-box" 
        ref={whiteBoxRef} 
        style={{ 
          backgroundColor: isDarkMode ? "#181818" : "#f0f0f0",
          padding: 0,
          margin: 0,
          overflow: "hidden"
        }}
      >
        <SkeletonLoader 
          count={skeletonCount} 
          styles={{
            height: skeletonRowHeight,
            width: "100%"
          }}
        />
      </div>
    );
  } else {
    return (
      <div className={`role_data ${isDarkMode ? "dark-mode" : "light-mode"}`}>
        <div
          className={`role-data-header ${
            isDarkMode ? "dark-mode" : "light-mode"
          }`}
        >
          <h3 className="title">
            {role?.name}
            {isRoleEditable(role) && (
              <span className="warn-msg">
                *You don't have permission to edit the role.
              </span>
            )}
          </h3>
          <div className="role-tabs">
            <ToggleButtonGroup
              value={selectedState}
              exclusive
              onChange={updateState}
              aria-label="Font Style"
              className="spark-btngroup small-toggle-button-group"
            >
              <ToggleButton
                value={1}
                className={selectedState === 1 ? "active" : ""}
              >
                Permissions
              </ToggleButton>
              <ToggleButton
                value={2}
                className={selectedState === 2 ? "active" : ""}
              >
                Regions & Assets
              </ToggleButton>
              {/* <ToggleButton value={3}>Notifications</ToggleButton> */}
            </ToggleButtonGroup>
          </div>
          {selectedState === 1 && (
            <div className="role-btns">
              {!role.default_role &&
                roleDetails &&
                roleDetails.permissions?.length &&
                !isSaveDisable &&
                hasPermissions(ROLES_CONTENT_PROPS.MODIFY_ROLE_PERMISSION) && (
                  <button
                    className="btn btn-outline"
                    disabled={isSaveButtonEnableDisable()}
                    onClick={saveChanges}
                  >
                    Save
                  </button>
                )}
              {!role.default_role && (
                <button
                  className="btn btn-outline"
                  disabled={isSaveButtonEnableDisable()}
                  onClick={() => resetValues(role)}
                >
                  Cancel
                </button>
              )}
            </div>
          )}

          {selectedState === 2 && (
            <div className="role-btns">
              {!role.default_role &&
                roleDetails &&
                roleDetails.permissions?.length &&
                !isSaveDisable && hasPermissions(ROLES_CONTENT_PROPS.MODIFY_ROLE_REGION_DEVICE) && (
                  <button
                    className="btn btn-outline"
                    onClick={saveChangesRegion}
                    disabled={!allRegionsSelected}
                  >
                    Save
                  </button>
                )}
              {!role.default_role && hasPermissions(ROLES_CONTENT_PROPS.MODIFY_ROLE_REGION_DEVICE) && (
                <button
                  className="btn btn-outline"
                  onClick={() => setSelectedState(1)}
                >
                  Cancel
                </button>
              )}
            </div>
          )}
        </div>
        <Dialog
          open={openDialog}
          onClose={() => handleDialogClose(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Alert"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to reset the values for "{role?.name}"?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleDialogClose(true)} color="primary">
              Ok
            </Button>
            <Button
              onClick={() => handleDialogClose(false)}
              color="primary"
              autoFocus
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <div
          className={`tool_management ${
            isDarkMode ? "dark-mode" : "light-mode"
          }`}
        >
          <div className="tool_management_inner">
            {selectedState === 1 && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                }}
              >
                <div
                  className={`tool_managementleft-inner ${
                    isDarkMode ? "dark-mode" : "light-mode"
                  }`}
                >
                  {/* <div className=""> */}
                  <div
                    className={`super-permission ${
                      isDarkMode ? "dark-mode" : "light-mode"
                    }`}
                    style={{
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "16px 40px",
                    }}
                  >
                    <div
                      className={`tool_label ${
                        isDarkMode ? "dark-mode" : "light-mode"
                      }`}
                    >
                      <label
                        style={{ color: isDarkMode ? "#a0a0a0" : "#666666" }}
                      >
                        Modules
                      </label>
                    </div>
                    <div className="tool_switch right_ele">
                      {!isRoleEditable(role) && (
                        // <Switch
                        //   checked={enableAll}
                        //   onChange={toggleEnableAll}
                        //   sx={{
                        //     "& .Mui-checked + .MuiSwitch-track": {
                        //       backgroundColor: "rgb(94, 214, 94);", // Replace with your desired color
                        //     },
                        //   }}
                        // />
                        <AntSwitch
                          checked={enableAll}
                          onChange={toggleEnableAll}
                        />
                      )}
                    </div>
                  </div>
                  <ul
                    className={`tool_list ${
                      isDarkMode ? "dark-mode" : "light-mode"
                    } scroll`}
                    
                    ref={scrollContainerRef}
                  >
                    {roleDetails?.permissions?.map((permission: any) => (
                      <li
                        key={permission.code}
                        className={`align-items-center tool-list-item${selectedPermission === permission ? " selected-permission" : ""} ${isDarkMode ? "dark-mode" : "light-mode"}`}
                        onClick={() => handlePermissionClick(permission)}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
            
<div
  className={`tool_label${selectedPermission === permission ? " selected-permission" : ""}`}
>
  <label>
    {permission.label}
  </label>
</div>
                          <div className="tool_switch right_ele">
                            {permission.type === "toggle" ? (
                              // <Switch
                              //   checked={roleCheck?.permissions[permission.code]}
                              //   onChange={(e) => toggleParentRole(e, permission, permission.subPermissions)}
                              //   disabled={isRoleEditable(role)}
                              //   sx={{
                              //     "& .Mui-checked + .MuiSwitch-track": {
                              //       backgroundColor: "rgb(94, 214, 94);",
                              //     },
                              //   }}
                              // />
                              <WhiteTooltip 
                                title="You don't have permission to edit the role"
                                arrow
                                placement="bottom"
                                disableHoverListener={!(isRoleEditable(role) || !hasPermissions(ROLES_CONTENT_PROPS.MODIFY_ROLE_PERMISSION))}
                              >
                                <span>
                                  <AntSwitch
                                    checked={
                                      roleCheck?.permissions[permission.code]
                                    }
                                    onChange={(e) =>
                                      toggleParentRole(
                                        e,
                                        permission,
                                        permission.subPermissions
                                      )
                                    }
                                    disabled={isRoleEditable(role) || !hasPermissions(ROLES_CONTENT_PROPS.MODIFY_ROLE_PERMISSION)}
                                  />
                                </span>
                              </WhiteTooltip>
                            ) : (
                              <div className="tool_value">
                                <div
                                  className={`value-button ${
                                    isRoleEditable(role) ? "disabled" : ""
                                  }`}
                                  onClick={() =>
                                    onStepperChange(
                                      role,
                                      permission.code,
                                      "decrement"
                                    )
                                  }
                                >
                                  -
                                </div>
                                <input
                                  type="number"
                                  value={role.permissions[permission.code]}
                                  readOnly
                                  className="pointer-events"
                                />
                                <div
                                  className={`value-button ${
                                    isRoleEditable(role) ? "disabled" : ""
                                  }`}
                                  onClick={() =>
                                    onStepperChange(
                                      role,
                                      permission.code,
                                      "increment"
                                    )
                                  }
                                >
                                  +
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                  {/* </div> */}
                </div>
                <div className="tool_managementright-inner">
                  <div className="super-permission">
                    <div className="tool_label">
                      <label
                        style={{ color: isDarkMode ? "#a0a0a0" : "#666666" }}
                      >
                        {selectedPermission?.label}
                      </label>
                    </div>
                  </div>
                  {selectedPermission &&
                    selectedPermission.label.length > 0 && (
                      <div>
                        {isToogle
                          ? renderAccordianContent(selectedPermission)
                          : renderSubPermissions(selectedPermission)}
                      </div>
                    )}
                </div>
              </div>
            )}
            {selectedState === 2 && (
              <div className="regions-assets">
                <RegionAssets
                  globalRegions={globalRegions}
                  globalDevicesFilter={globalDevicesFilter}
                  setGlobalRegions={setGlobalRegions}
                  setGlobalDevicesFilter={setGlobalDevicesFilter}
                  extractIdLabelTree={extractIdLabelTree}
                  setGlobalRegionsIdLabel={setGlobalRegionsIdLabel}
                  fetchGlobalDevices={fetchGlobalDevices}
                  loadingRegions={loadingRegions}
                  loadingDevices={loadingDevices}
                  onAllRegionsSelectedChange={setAllRegionsSelected}
                />
              </div>
            )}
            {selectedState === 3 && (
              <div className="notifications">
                {/* Notifications content here */}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default RolePermissions;
